export interface TourStep {
  targetSelector: string
  title: string
  description: string
  placement: 'top' | 'bottom' | 'left' | 'right'
}

export const TOUR_STEPS: TourStep[] = [
  {
    targetSelector: '[data-tour="connect-data"]',
    title: 'Connect Your Data',
    description:
      'Connect pre-configured MCP servers, custom servers, S3 storage, and APIs to your Vendia workspace. Once connected, they become instantly available to your AI agents.',
    placement: 'right',
  },
  {
    targetSelector: '[data-tour="connect-agent"]',
    title: 'Connect Your AI Agent',
    description: 'Wire up Claude, ChatGPT, Cursor, or any MCP-compliant AI agent to query your connected data.',
    placement: 'left',
  },
  {
    targetSelector: '[data-tour="nav-dashboard"]',
    title: 'Dashboard',
    description: 'Monitor your MCP Gateway activity, connected servers, and data sources at a glance.',
    placement: 'right',
  },
  {
    targetSelector: '[data-tour="nav-mcp-servers"]',
    title: 'MCP Servers',
    description:
      'Select which MCP tools to enable for your AI agent(s). Manage authentication and select which tools to expose.',
    placement: 'right',
  },
  {
    targetSelector: '[data-tour="nav-storage-connections"]',
    title: 'Storage Connections',
    description:
      'Connect and access your Amazon S3 buckets via Vendia. Your AI agent(s) can browse, read, and write files - text, images, and PDFs',
    placement: 'right',
  },
  {
    targetSelector: '[data-tour="nav-api-connections"]',
    title: 'API Connections',
    description:
      'Add and use OpenAPI/Swagger specifications to enable AI-driven API discovery and interaction via the Vendia MCP Gateway.',
    placement: 'right',
  },
  {
    targetSelector: '[data-tour="nav-govern"]',
    title: 'Govern',
    description:
      'Configure security guardrails and rate limits to control how AI agents access your data. Set per-user, per-credential, and per-connection usage policies.',
    placement: 'right',
  },
  {
    targetSelector: '[data-tour="nav-observe"]',
    title: 'Observe',
    description:
      'Track every AI agent query with read receipts and transaction tracing. Monitor tool calls, audit data access, and troubleshoot issues across your MCP Gateway.',
    placement: 'right',
  },
  {
    targetSelector: '[data-tour="nav-admin"]',
    title: 'Admin',
    description:
      'Manage your organization — create API credentials for AI agents that use static OAuth (non-DCR), assign roles, and oversee your projects.',
    placement: 'right',
  },
]

export const TOUR_STORAGE_KEY = 'vendia_guided_tour_completed'
